function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'sable': 'rgb(180, 174, 152)','indigo': 'rgb(21, 48, 89)','terracotta': 'rgb(233, 171, 148)','aubergine': 'rgb(84, 90, 143)','sage': 'rgb(193, 217, 193)','natural': 'rgb(255, 255, 255)','charcoal': 'rgb(119, 132, 131)',};

    this.images = {'field-forest': 'url("//junctionfibermill.com/cdn/shop/files/swatchfieldandforest_120x.jpg?v=14686202913070557468")','tangerine-wave': 'url("//junctionfibermill.com/cdn/shop/files/swatchtangerinewave_120x.jpg?v=6352414776951512032")','golden-harvest': 'url("//junctionfibermill.com/cdn/shop/files/swatchgoldenharvest_120x.jpg?v=9243269574685018803")','harvest-night': 'url("//junctionfibermill.com/cdn/shop/files/swatchharvestnight_120x.jpg?v=8048741955960795593")','dahlia-bloom': 'url("//junctionfibermill.com/cdn/shop/files/swatchdahliabloom_120x.jpg?v=10875890084150688072")','lovestruck': 'url("//junctionfibermill.com/cdn/shop/files/swatchlovestruck_120x.jpg?v=2364094651929257727")','midnight-indigo': 'url("//junctionfibermill.com/cdn/shop/files/swatchmidnightindigo_120x.jpg?v=5935882148853127746")','frosted-violet': 'url("//junctionfibermill.com/cdn/shop/files/swatchfrostedviolet_120x.jpg?v=5683141429364644052")','golden-slate': 'url("//junctionfibermill.com/cdn/shop/files/swatchgoldenslate_120x.jpg?v=9404125456236514855")','autumn-ember': 'url("//junctionfibermill.com/cdn/shop/files/swatchautumnember_120x.jpg?v=13040529906601536483")','blush-heather': 'url("//junctionfibermill.com/cdn/shop/files/swatchblushheather_120x.jpg?v=4084638607351753834")','lizs-way': 'url("//junctionfibermill.com/cdn/shop/files/swatchlizway_120x.jpg?v=1625201313747749019")','pine-sunset': 'url("//junctionfibermill.com/cdn/shop/files/swatchpinesunset_120x.jpg?v=17059498155761942128")','alpine-haze': 'url("//junctionfibermill.com/cdn/shop/files/swatchalpinehaze_120x.jpg?v=5258735020311272374")','rustic-glow': 'url("//junctionfibermill.com/cdn/shop/files/swatchrusticglow_120x.jpg?v=15929623943988089935")','stones-end': 'url("//junctionfibermill.com/cdn/shop/files/swatchstonesend_120x.jpg?v=4176722196507128442")','seagreen': 'url("//junctionfibermill.com/cdn/shop/files/swatchseagreen_120x.jpg?v=10489493032763177035")','natural-borealis': 'url("//junctionfibermill.com/cdn/shop/files/swatchnaturalborealis_120x.jpg?v=7463643268984569804")','natural-plum': 'url("//junctionfibermill.com/cdn/shop/files/swatchnaturalplum_120x.jpg?v=6133841308320057582")','natural-leaves': 'url("//junctionfibermill.com/cdn/shop/files/swatchnaturalleaves_120x.jpg?v=15089445489194119164")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
